import React from 'react';
import { arrayOf } from 'prop-types';
import Moment from 'moment';

import {
   DetailedRow,
   DetailedRowContent,
   SectionHeader,
} from './DetailedSearchRow';
import { endorsementType } from '../types';

const LONG_DATE_FORMAT = 'D MMM YYYY';

const CurrentEndorsementRow = ({ endorsement }) => {
   return (
      <DetailedRowContent>
         <div className="col s12">
            <span className="bold black-text">{endorsement.endorsementTypeName}</span>
            <br />
            <span className="pr-subtext">
               Endorsed from{' '}
               {Moment(endorsement.endorsementStartDate).format(LONG_DATE_FORMAT)} to{' '}
               {Moment(endorsement.endorsementExpiryDate).format(LONG_DATE_FORMAT)}
            </span>
         </div>
      </DetailedRowContent>
   );
};

CurrentEndorsementRow.propTypes = {
   endorsement: endorsementType.isRequired,
};

export const CurrentEndorsementsContent = ({ endorsements }) => {
   const endorsementRows = endorsements.map(e => (
      <CurrentEndorsementRow key={e.endorsementId} endorsement={e} />
   ));

   return (
      <>
         <SectionHeader label="Current Endorsements" />
         {endorsementRows}
      </>
   );
};

const CurrentEndorsements = ({ endorsements }) => (
   <DetailedRow>
      <CurrentEndorsementsContent endorsements={endorsements} />
   </DetailedRow>
);

CurrentEndorsements.propTypes = {
   endorsements: arrayOf(endorsementType).isRequired,
};

export default CurrentEndorsements;
